import React from "react";
import GoToBackButton from "../../../elements/goToBack/GoToBack";
import { NavLink, useHistory } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledBreakWord } from "../../../styles/styledBreakWord";

const SupportUserDetailsInfo = ({ user, notification, setNotification }) => {
  const { t } = useTranslation("supportUserPage");

  const history = useHistory();

  if (!user) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  return (
    <StyledContentWrapper height="auto" className="support-user-details-head">
      <GoToBackButton pt="20" pb="30" handler={() => {history.goBack();}} />
      <div className="support-user-info">
        <div className="support-user">
          <div className="support-user__image">
            {!user.firstname ? "-" : user.firstname.charAt(0)}
          </div>
          <div className="support-user__name">
            <StyledBreakWord>
              {!user.firstname || !user.lastname ? <span>{t("details.nameIsMissing")}</span> : `${user.firstname} ${user.lastname}`}
            </StyledBreakWord>
          </div>
        </div>
        <div className="support-user-info__content">
          <div className="support-user-info__row support-user-info__email" title="E-mail">
            <span className="icon-light-mail" />
            <CopyToClipboard
              text={user.email}
              onCopy={() => {
                setNotification({ ...notification, visible: true, type: "success", message: t("details.copied") });
              }}
            >
              <p>
                {user.email}
              </p>
            </CopyToClipboard>
          </div>
          <div className="support-user-info__row support-user-info__registration">
            <span className="icon-light-calendar" />
            <p>
              {TimestampToDateMoment(user.createDate)}
            </p>
          </div>
        </div>
      </div>
    </StyledContentWrapper>
  );
};

export default SupportUserDetailsInfo;